/* eslint semi: 1 */

import { PageResponse } from '../player-setup-communication';
import PlayerSetupFormError from '../player-setup-form-error/player-setup-form-error-tmpl';
import PlayerSetupLicenseIcon from '../player-setup-license-icon/player-setup-license-icon-tmpl';
import CommonOptionsMixin from '@/components/mixins/common-options-mixin';
import OnEnterMixin from '@/components/mixins/onenter-mixin';

export const PLAYER_APPLICATIONS = {
  APP_SINGLE: 'application-single',
  APP_MIRRORING: 'application-mirroring',
  APP_VIDEOWALL: 'application-videowall',
  APP_LED: 'application-led'
};

export default {
  name: 'player-setup-application',
  components: {
    PlayerSetupFormError,
    PlayerSetupLicenseIcon
  },
  mixins: [CommonOptionsMixin, OnEnterMixin],
  props: {
    nextPage: {
      type: [String, Object, null],
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    },
    licenses: {
      type: Array,
      default () {
        return [];
      }
    },
    isLEDAvailable: {
      type: Boolean,
      default: false
    },
    isDiscovery: {
      type: Boolean,
      default: true
    },
    isPremium: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFormDisabled: false,
      model: {
        application: PLAYER_APPLICATIONS.APP_SINGLE
      },
      isArabic: navigator?.language === 'ar'
    };
  },
  computed: {
    applications () {
      return PLAYER_APPLICATIONS;
    }
  },
  watch: {
    'model.application' (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.$emit('SetApplication', this.model.application);
      }
    }
  },
  methods: {
    /** Trigger form submit when user hit enter */
    onEnter (event) {
      this.triggerFormSubmit();
    },
    async submitForm () {
      return PageResponse(false, this.nextPage, {
        application: this.model.application
      });
    },
    async triggerFormSubmit (event) {
      this.$emit('SubmitForm');
      return false;
    }
  }
};
